var map = {
	"./Timg.png": 241,
	"./arrow-down-blue.svg": 480,
	"./arrow-down-grey.svg": 481,
	"./arrow-right-white.png": 482,
	"./arrow-right.png": 242,
	"./arrow-right.svg": 483,
	"./arrow2.png": 109,
	"./arrowLeft.png": 137,
	"./arrowRight.png": 138,
	"./bannerBg.jpg": 243,
	"./bannerEl.png": 139,
	"./blue-loader.svg": 484,
	"./caution.png": 244,
	"./chart.png": 485,
	"./chartIco.png": 245,
	"./chartIco2.png": 246,
	"./chartSm.png": 486,
	"./check.png": 197,
	"./circle-grey.svg": 487,
	"./circle.svg": 488,
	"./clock.png": 162,
	"./coinbaseWalletIcon.svg": 159,
	"./confirm.png": 247,
	"./copy.png": 489,
	"./cross.png": 40,
	"./discord.png": 248,
	"./down.png": 163,
	"./dropdown-blue.svg": 490,
	"./dropdown.svg": 491,
	"./dropup-blue.svg": 492,
	"./errInfo.png": 249,
	"./errorIco.png": 240,
	"./eth.png": 493,
	"./ethereum-logo.png": 250,
	"./fail.png": 251,
	"./fortmaticIcon.png": 494,
	"./globe.png": 252,
	"./info.png": 253,
	"./leftArrow.png": 164,
	"./link.svg": 495,
	"./logo.png": 254,
	"./logo2.png": 255,
	"./magnifying-glass.svg": 496,
	"./menu.svg": 497,
	"./metamask.png": 140,
	"./plus-blue.svg": 498,
	"./plus-grey.svg": 499,
	"./portisIcon.png": 500,
	"./question-mark.svg": 501,
	"./question.png": 502,
	"./question.svg": 503,
	"./reset.png": 256,
	"./search.png": 95,
	"./setting.png": 257,
	"./spinner.svg": 504,
	"./startimg.png": 258,
	"./swap.png": 57,
	"./tather.png": 505,
	"./telegram.png": 259,
	"./tick.png": 260,
	"./token-list-logo.png": 506,
	"./token-list/lists-dark.png": 507,
	"./token-list/lists-light.png": 508,
	"./trustWallet.png": 509,
	"./trustimg.png": 261,
	"./twitter.png": 262,
	"./waiting.png": 263,
	"./wallet.png": 94,
	"./walletConnectIcon.svg": 160,
	"./walletconnect.png": 510,
	"./x.svg": 511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 218;